module.exports = __webpack_public_path__ + "img/home_server_2.721cb99b.png";